export default __webpack_public_path__ + "static/Rectangle-315-e488675f30e627bb53a6620548e2aef6.jpg";